import React, { useState, useEffect } from 'react';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import { Select, Modal } from 'antd';

const { Option } = Select;

const industryColors = {
  'AUTOMOBILES': 'rgba(98, 178, 253, 1)',
  'BFSI': 'rgba(107, 54, 105, 1)',
  'CONSUMER DURABLES': 'rgba(1, 115, 184, 1)',
  'E-COMMERCE': 'rgba(85, 94, 181, 1)',
  'EDUCATION': 'rgba(221, 246, 191, 1)',
  'FMCG': 'rgba(255, 180, 79, 1)',
  'GOVT SECTOR': 'rgba(249, 155, 171, 1)',
  'HOSPITALITY': 'rgba(238, 48, 116, 1)',
  'INFRASTRUCTURE': 'rgba(253, 111, 228, 1)',
  'LIFESTYLE': 'rgba(155, 223, 196, 1)',
  'MEDIA & ENTERTAINMENT': 'rgba(255, 132, 106, 1)',
  'TELECOM': 'rgba(85, 94, 181, 1)',
  'TRAVEL & TOURISM': 'rgba(15, 139, 127, 1)',
};

const MonthlyCategoryChart = () => {
  const [selectedYear, setSelectedYear] = useState('2023'); // Default year
  const [chartData, setChartData] = useState(null);
  const [originalData, setOriginalData] = useState([]); // State for storing original API data
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [avgDuration, setAvgDuration] = useState(null);
  const [brandName, setBrandName] = useState(null);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiBaseUrl}/analysisApi/get_industry?start_year=${selectedYear}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            start_year: selectedYear,
          }),
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log(data);

        setOriginalData(data); // Store the original data
        const transformedData = transformData(data);
        setChartData(transformedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [selectedYear]);

  const transformData = (data) => {
    const labels = data.map(item => item.brandSegment.toUpperCase());
    const avgDurations = data.map(item => item.avg_duration);
    const colors = labels.map(label => industryColors[label] || '#CCCCCC'); // Fallback color

    return {
      labels,
      datasets: [{
        data: avgDurations,
        backgroundColor: colors,
        hoverBackgroundColor: colors,
      }],
    };
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  const handlePieClick = (event, elements) => {
    if (elements.length > 0) {
      const index = elements[0].index;
      const industry = chartData.labels[index];
      const duration = chartData.datasets[0].data[index];
      const brand = originalData[index].brandName; // Accessing brandName from original data

      setSelectedIndustry(industry);
      setAvgDuration(duration);
      setBrandName(brand);
      setIsModalVisible(true);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedIndustry(null);
    setAvgDuration(null);
    setBrandName(null);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' ,flexDirection:"column",justifyContent:"center"}}>
      <div style={{ display:"flex",justifyContent:"end",width:"100%"}}>
        <Select value={selectedYear} onChange={handleYearChange} style={{ width: "200px" }}>
          <Option value="2022">2022</Option>
          <Option value="2023">2023</Option>
          <Option value="2024">2024</Option>
        </Select>
      </div>
      <div style={{ flex: 2, display: 'flex', justifyContent: 'center' }}>
        {chartData && (
          <div style={{width:"600px"}}>
          <Pie
            data={chartData}
            options={{
              plugins: {
                tooltip: {
                  callbacks: {
                    label: function (tooltipItem) {
                      const dataIndex = tooltipItem.dataIndex;
                      const avgDuration = chartData.datasets[0].data[dataIndex];
                      const brandSegment = chartData.labels[dataIndex];
                      return `Duration: ${avgDuration}, Segment: ${brandSegment}`;
                    }
                  }
                },
                legend: {
                  display: true,
                  position: 'right', // Position the legend on the right
                  align: 'center', // Center-align the legend
                  labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                  }
                }
              },
              onClick: handlePieClick
            }}
          />
          </div>
        )}
      </div>
      <Modal
        title="Industry Information"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        {selectedIndustry && avgDuration !== null && brandName && (
          <div>
            <br /><br />
            <p><strong>Industry:</strong> {selectedIndustry}</p>
            <p><strong>Average Duration:</strong> {avgDuration}</p>
            <p><strong>Industy Top Brand Name:</strong> {brandName}</p>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default MonthlyCategoryChart;